module.exports = __webpack_public_path__ + "static/media/communication.65a7f806.svg";